import { useMutation } from "@apollo/client";
import { DecisionState } from "types/graphql-schema";

import getArtifactActivitiesQuery from "@apps/artifact-sidebar/graphql/get-artifact-activities-query";
import getDashboardGoalsQuery from "@apps/dashboard-new/graphql/get-dashboard-goals-query";
import { buttonTheme } from "@components/button/button";
import DeprecatedSelect from "@components/select/select";

import updateArtifactMutation from "../graphql/update-artifact-mutation";

const DecisionStateComponent = ({
  artifact,
  className,
  iconSize = "4",
}: {
  artifact: {
    id: number;
    decisionState?: DecisionState | null;
    canUpdate: {
      permission: boolean;
    };
  };
  className?: string;
  iconSize?: string;
}) => {
  const [updateArtifact] = useMutation(updateArtifactMutation);

  const handleChangeState = ({ value: newState }: { value: DecisionState }) => {
    updateArtifact({
      variables: {
        artifactId: artifact.id,
        additionalFields: { decisionState: newState },
      },
      optimisticResponse: {
        createOrUpdateArtifact: {
          artifact: {
            ...artifact,
            decisionState: newState,
          },
          __typename: "CreateOrUpdateArtifactMutation",
        },
      },
      refetchQueries: [getDashboardGoalsQuery, getArtifactActivitiesQuery],
    });
  };

  return (
    <DeprecatedSelect
      disabled={!artifact.canUpdate.permission}
      options={[
        {
          value: DecisionState.Draft,
          label: "Draft",
        },
        {
          value: DecisionState.Decided,
          label: "Decided",
        },
      ]}
      value={artifact.decisionState}
      onChange={handleChangeState}
      buttonProps={{
        theme: buttonTheme.text,
        "aria-label": "Decision state dropdown button",
      }}
    />
  );
};

export default DecisionStateComponent;
